module.exports = __webpack_public_path__ + "static/media/coSponsorsBy.1bbd770c.png";